export enum AdministrationTab {
  Activities = 'activities-tab',
  Locations = 'locations-tab',
  Users = 'users-tab',
}
